import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Calendars = {
  List: lazyNamed(() => import('./containers/CalendarsList/index.tsx'), 'CalendarsList'),
  Form: lazyNamed(() => import('./containers/CalendarForm/index.tsx'), 'CalendarForm'),
};
